import Joyride, { type CallBackProps } from "react-joyride";
import type { Step } from "react-joyride";
import { joyrideLocale, joyrideStyles } from "@/modules/hr/presentation/tour/joyrideConfig";

type CommunicationTourProps = {
  steps: Step[];
  run: boolean;
  onCallback: (data: { status?: string; type?: string; index?: number }) => void;
};

export function CommunicationTour({
  steps,
  run,
  onCallback,
}: CommunicationTourProps) {
  const handleCallback = (data: CallBackProps) => {
    onCallback({
      status: data.status,
      type: data.type,
      index: data.index,
    });
  };

  return (
    <Joyride
      steps={steps}
      run={run}
      continuous
      showProgress
      showSkipButton
      callback={handleCallback}
      locale={joyrideLocale}
      styles={joyrideStyles}
    />
  );
}
